
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AiComicPage from "../pages/aicomic/page";
import EmotionalAiPage from "../pages/emotional-ai/page";
import ContactPage from "../pages/contact/page";
import ComingSoonPage from "../pages/coming-soon/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/aicomic",
    element: <AiComicPage />,
  },
  {
    path: "/emotional-ai",
    element: <EmotionalAiPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/coming-soon",
    element: <ComingSoonPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
